import React, { useEffect, useState } from "react";
import { useRouter } from "next/router";
import styles from "./sticky-foot.module.scss";
import useWindowSize from "../../hooks/useWindowSize";
import * as fbq from "../../lib/fpixel";
import ReactGA from "react-ga";


const StickyFoot = ({ product = {}, scroll }) => {
  const router = useRouter();
  const size = useWindowSize();

  const handleCheckout = () => {
    localStorage.setItem("init_checkout", "true");

    // window.webengage.track("Initiate Checkout", {
    //   "Product ID": product.id,
    //   "Product Name": product.name,
    //   "Product Category": product.category ? product.category.name : "",
    //   //todo "Exam Name": !not coming from the backend + need to be populated in DB,
    //   Amount: product.offer_price,
    //   Subdomain: "web.toppersnotes.com",
    //   "FPJS ID":
    //     localStorage.getItem("FPJS") &&
    //     localStorage.getItem("FPJS").replace(/"/g, ""),
    // });
    let product2 = {
      id: product.id,
      name: product.name,
      engName: product.engName,
      lang: product.lang,
      category: product.category,
      offer_price: product.offer_price,
      price: product.price,
      img1: product.img1,
      product_link: product.product_link,
      no_of_books: product.no_of_books,
      rating: product.rating,
      numOfReviews: product.numOfReviews,
      isVirtual: product.isVirtual,
      sku: product.sku,
      exam: product.exam_name,
      exam_id: product.exam_id,
    };

    ReactGA.plugin.require("ec");
    ReactGA.plugin.execute("ec", "addTocart", {
      id: product2.sku || createSkuFromName(product2.name),
      name: product2.name,
      sku: [product2.sku || createSkuFromName(product2.name)],
      category: product2.exam,
      price: product2.offer_price,
      quantity: 1,
      currency: "INR",
    });
    ReactGA.plugin.execute("ec", "setAction", "add_to_cart", {
      currency: "INR",
    });
    ReactGA.pageview(window.location.pathname + window.location.search);
    ReactGA.plugin.execute("ec", "clear");

    //fbq
    fbq.event("addTocart", {
      content_name: product2.name,
      content_type: "product",
      content_ids: [product2.sku || createSkuFromName(product2.name)],
      category_name: product2.category ? product2.category : "",
      value: product2.offer_price,
      subtotal: product2.offer_price,
      page_title: "Checkout",
      contents: [
        {
          id: product2.sku || createSkuFromName(product2.name),
          quantity: 1,
          price: product2.offer_price,
        },
      ],
      currency: "INR",
      num_items: 1,
    });

    localStorage.setItem("Products", JSON.stringify(product2));
    localStorage.setItem("userLang", product.lang);

    router.push("/checkout?id=" + product.id, null, { shallow: true });
  };
  return (
    <>
      {scroll > 600 && size && size.width <= 650 && (
        <div className={`${styles.footer} bg-white py-2`}>
          <div className="px-3 mx-auto flex justify-between items-center align-middle">
            <div style={{ width: "100%" }}>
              <h3
                onClick={() => {
                  handleCheckout();
                }}
                className={`bg-tn-orange ${styles.textUppercase} py-3 rounded-lg text-center px-9 text-xl text-white hover:cursor-pointer`}
              >
                Buy Now
              </h3>
            </div>
          </div>
        </div>
      )}
      {size && size.width > 650 && (
        <div className={`${styles.footer} bg-white py-2`}>
          <div className="px-3 mx-auto flex justify-between items-center align-middle">
            <div className="flex sm:gap-6 gap-3 items-center sm:justify-start justify-center">
              <h3 className="text-2xl sm:text-3xl font-bold">
                ₹ {product.offer_price}
              </h3>
            </div>
            <div style={{ width: "auto" }}>
              <h3
                onClick={() => {
                  handleCheckout();
                }}
                className={`bg-tn-orange ${styles.textUppercase} py-3 rounded-lg text-center px-9 text-xl text-white hover:cursor-pointer`}
              >
                Buy Now
              </h3>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default StickyFoot;
